import React from "react";
import {
  AppstoreOutlined,
  BarChartOutlined,
  BulbOutlined,
  DashboardOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  MobileOutlined,
  PoweroffOutlined,
  QuestionCircleOutlined,
  RightCircleOutlined,
  SettingOutlined,
  ToolOutlined,
} from "@ant-design/icons";

export const AppStorageKeys = {
  appEnv: "app_env",
  envVars: "ENV_VARS",
  userRoles: "USER_ROLES",
  currentUser: "current_user",
  tipTech: "tip_tech",
  tipMessage: "tip_message",
  favDevices: "favoriteDevices",
};

export const AppEnvs = {
  HS: "HomeSight",
  HA: "HACloud",
  SA: "StandAlone",
};

export const DeviceManagePaths = {
  home: "home",
  device: "device",
  group: "group",
  code: "asset",
  order: "order",
  network: "network",
  purOrder: "purOrder",
  updatePassword: "reset_password",
};

export const UserMenuItems = {
  updatePassword: {
    key: "update_password",
    label: "Change Password",
    icon: (props) => <ToolOutlined {...props} />,
  },
  betaPortal: {
    key: "beta_portal",
    label: "Try the Beta UI",
    icon: (props) => <RightCircleOutlined {...props} />,
  },
  alphaPortal: {
    key: "aplha_portal",
    label: "Try Homesight Portal",
    icon: (props) => <RightCircleOutlined {...props} />,
  },
};

export const NavMenuItems = {
  network: {
    key: "network",
    label: "Network Dashboard",
    icon: (props) => <DashboardOutlined {...props} />,
  },
  support: {
    key: "home",
    label: "Support View",
    icon: (props) => <HomeOutlined {...props} />,
    disabled: false,
  },
  device: {
    key: "device",
    label: "Provisioning",
    icon: (props) => <MobileOutlined {...props} />,
    disabled: false,
  },
  order: {
    key: "order",
    label: "Orders",
    icon: (props) => <FileDoneOutlined {...props} />,
    disabled: false,
  },
  group: {
    key: "group",
    label: "Groups",
    icon: (props) => <AppstoreOutlined {...props} />,
    disabled: false,
  },
  asset: {
    key: "code",
    label: "Software Management",
    icon: (props) => <FileProtectOutlined {...props} />,
    disabled: false,
  },
  trouble: {
    key: "trouble",
    label: "Troubleshooting",
    icon: (props) => <ToolOutlined {...props} />,
    disabled: true,
  },
  stats: {
    key: "stats",
    label: "Statistics & Reporting",
    icon: (props) => <BarChartOutlined {...props} />,
    disabled: true,
  },
  admin: {
    key: "admin",
    label: "Admin Settings",
    icon: (props) => <SettingOutlined {...props} />,
    disabled: true,
  },
  help: {
    key: "help",
    label: "Help",
    icon: (props) => <QuestionCircleOutlined {...props} />,
    disabled: true,
  },
  tips: {
    key: "tips",
    label: "Tips",
    icon: (props) => <BulbOutlined {...props} />,
    disabled: true,
  },
  about: {
    key: "about",
    label: "About",
    icon: (props) => <InfoCircleOutlined {...props} />,
    disabled: false,
  },
  logout: {
    key: "logout",
    label: "Log Out",
    icon: (props) => <PoweroffOutlined {...props} />,
    disabled: false,
  },
};

/** Menu to be displayed when user choose to hide Tips page */
export const DefaultMenu = NavMenuItems.support.key;
/** Menu to be displayed for base path, keeps it Tips page */
export const DefaultBasePathMenu = NavMenuItems.support.key;

export const APIResponseErrorCodes = {
  sessionExpired: "Token-Verification-Failure",
  unauthorizedAccess: "UserAccess-to-Method-NotAllowed",
};

/** Keys */
export const MessageKeys = {
  apiError: "api_error",
};
